import { useState } from 'react'
import './Research.css'

import Publication from '../../Components/Publication/Publication'
import SEO from '../../Components/SEO/SEO'
import PageTitle from '../../Hooks/PageTitle';

import clarix_art from '../../Media/Research.Media/clarix.jpg'

const Research = () => {
    PageTitle('Research');
    const [selectedType, setSelectedType] = useState('All Types');
    const [selectedField, setSelectedField] = useState('All Fields');
    const [selectedRole, setSelectedRole] = useState('All Roles');
    const [selectedDate, setSelectedDate] = useState('All Years');

    const handleFilterChange = (event, setter) => {
        setter(event.target.value);
    };

    const filterPublications = (publication) => {
        const typeMatch = selectedType === 'All Types' || publication.type === selectedType;
        const fieldMatch = selectedField === 'All Fields' || publication.field === selectedField;
        const roleMatch = selectedRole === 'All Roles' || publication.role === selectedRole;
        const dateMatch = selectedDate === 'All Years' || publication.date === selectedDate;

        return typeMatch && fieldMatch && roleMatch && dateMatch;
    };

    const publications = [
        // pulsex
        // adas
        {
			available: true,
            onClick:() => window.open('https://thesai.org/Publications/ViewPaper?Volume=17&Issue=5&Code=IJACSA&SerialNo=83', '_blank'),
            image:clarix_art,
            title:"Optimizing Whiteboard Digitization with Clarix",
            date:'2026',
            authors:["Abdellah NABOU","Mohammed Ameksa","Hajar Ezzzahoud","Yassine Bazgour","Zahra Abouhane"],
            role:"Co-Author",
            field:"Computer Vision",
            venue:"International Journal of Advanced Computer Science and Applications (IJACSA)",
            volume:"17",
            issue:"5",
            quartile:"Q3",
            pages:"8",
            reads:"+80",
            doi:"10.14569/IJACSA.2026.0170583",
            status:"Published", // Published | Accepted | Under Review | Preprint
            type:"Journal Article", // Journal Article | Conference Paper | Workshop Paper | Preprint | Technical Report | Poster / Extended Abstract
            tags:["Computer Vision", "OCR", "LLM", "Embedded AI", "Raspberry Pi", "System Design", "Benchmarking", "Implementation", "Evaluation"],
            affiliation:"Faculty of Sciences Semlalia, Cadi Ayyad University",
            publisher:"IJACSA",
            citation:""
        }
    ];

	return (
		<>
			<SEO 
                title="Research"
                description="Academic research and publications in artificial intelligence, machine learning, and computer science. Exploring cutting-edge topics in deep learning, computer vision, natural language processing, and intelligent systems."
                url="https://yassinebazgour.vercel.app/Research"
                keywords="AI research, machine learning research, computer science research, academic publications, deep learning papers, computer vision research, NLP research, artificial intelligence studies"
            />

            <section className='research-section'>
                <span className='research-title'>Research</span>
                <span className='research-description'>Research articles, papers, and scientific publications I authored or co-authored.</span>
                <span className='research-count-span'>
                    Released Publications:
                    <span className='research-count-number'> {publications.filter(p => p.available).length}</span>
                </span>
                <div className='research-selects-container'>
                    <select className='research-select research-publication-select' onChange={(e) => handleFilterChange(e, setSelectedType)}>
                        <option>All Types</option>
                        <option>Journal Article</option>
                        {/* <option>Conference Paper</option>
                        <option>Workshop Paper</option>
                        <option>Preprint</option>
                        <option>Technical Report</option>
                        <option>Poster / Extended Abstract</option> */}
                    </select>
                    <select className='research-select research-role-select' onChange={(e) => handleFilterChange(e, setSelectedRole)}>
                        <option>All Roles</option>
                        <option>First Author</option>
                        <option>Co-Author</option>
                    </select>
                    <select className='research-select research-field-select' onChange={(e) => handleFilterChange(e, setSelectedField)}>
                        <option>All Fields</option>
                        <option>Computer Vision</option>
                    </select>
                    <select className='research-select research-date-select' onChange={(e) => handleFilterChange(e, setSelectedDate)}>
                        <option>All Years</option>
                        <option>2026</option>
                    </select>
                </div>
                <div className='research-container'>
                    {publications.filter(filterPublications).length === 0 ? (
                        <span className='no-available-publication'>No research publications are available for the selected filters. 😔</span>
                    ) : (
                        publications.filter(filterPublications).map((publication, index) => (
                            <Publication 
                                key={index}
                                {...publication}
                            />
                        ))
                    )}
                </div>
            </section>
		</>
	)
}

export default Research